import { FeeStatusEnum } from '../interfaces';

export const PAYMENT_STATUS_COLOR = {
  [FeeStatusEnum.Pending as string]: 'warning',
  [FeeStatusEnum.Sent as string]: 'success',
};
